import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=e620f85c"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&id=e620f85c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports